<template>
  <div>

    <!-- Available subscriptions-->
      <select v-model="selectedSubscription">
        <option value="" disabled>Select a subscription</option>
        <option v-for="subscription in subscriptions" v-bind:value="subscription"
          :key="subscription.id"
          :disabled="subscription.type === 'lead_scanner'">
          {{ subscription.type }} - {{ subscription.duration }} {{ subscription.duration_type }}
        </option>
      </select>
      <button @click="addSubscription()">Add</button>

      <!-- Current subscriptions -->
      <Subscription v-for="subscription in account.subscriptions" :key="subscription.id" :subscription="subscription"
        v-on:update="updateSubscription" v-on:remove="removeSubscription"/>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

<script>
import { mapState } from 'vuex'
import Subscription from '@/components/Subscription.vue'

export default {
  name: 'accountSubscriptions',
  components: {
    Subscription
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode',
      'subscriptions'
    ])
  },
  data () {
    return {
      selectedSubscription: null,
    }      
  },
  methods: {
    addSubscription () {
      if (!this.selectedSubscription) return
      this.$store.dispatch('addAccountSubscription', { account: this.account, subscription: this.selectedSubscription })
    },
    updateSubscription ({ subscription, params} ) {
      this.$store.dispatch('updateAccountSubscription', {
          account: this.account,
          subscription: subscription,
          params: params
        })
    },
    // eslint-disable-next-line no-unused-vars
    removeSubscription ({subscription, partner}) {
      var response = confirm("Are you sure you want to remove this subscription?")
      if (response) {
        this.$store.dispatch('removeAccountSubscription', {
          account: this.account,
          subscription: subscription
        })
      }
    }
  }
}
</script>
